import type { TFunction } from "i18next";
import U2000SaveCancelDialog from "../../../../../u2000Core/components/dialog/U2000SaveCancelDialog";
import type { U2104AffilaitionRoleHandler } from "./U2104AffilaitionRoleHandlers";
import type { U2104Role } from "../../../../U2104Service";

// Typage des props du composant
interface U2104AffilaitionRoleDlgProps {
  u2104AffilaitionRoleHandler: U2104AffilaitionRoleHandler;
  t: TFunction;
  NS: string;
}

// Composant pour le dialogue d'édition des actions d'une unité logique
function U2104AffilaitionRoleEditDlg({ u2104AffilaitionRoleHandler, t, NS }: U2104AffilaitionRoleDlgProps) {
  // Unified handler that manages Save and Cancel differently
  const handleClose = (action: "save" | "cancel") => {
    // For this component, we don't have formStateHandlers, so just pass through the action
    u2104AffilaitionRoleHandler.onDlgClose(action);
  };

  // renmder
  return (
    <U2000SaveCancelDialog width="w-[700px]" isOpen={u2104AffilaitionRoleHandler.isDialogOpen} onClose={handleClose} title={t("user.lblRole", { ns: NS })}>
      <div className="flex flex-col gap-y-4">
        {u2104AffilaitionRoleHandler.roles &&
          u2104AffilaitionRoleHandler.roles.map((role: U2104Role, index) => (
            <div key={index} className="mb-1 flex items-center gap-x-2">
              <div
                className={`h-6 w-6 cursor-pointer rounded-sm border-2 transition-colors duration-300 ${role.idChecked ? "border-blue-500 bg-blue-100" : "border-gray-300 bg-white"}`}
                onClick={() => u2104AffilaitionRoleHandler.onCheckRole(role)}
              >
                {role.idChecked && (
                  <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <p className="inline-block text-gray-800">
                {role.roleCode} - {role.roleDescription}
              </p>
            </div>
          ))}
      </div>
    </U2000SaveCancelDialog>
  );
}

export default U2104AffilaitionRoleEditDlg;
